module.exports = __webpack_public_path__ + "img/p11.daa8f8ab.png";